import camelCase from 'lodash/camelCase';
import getSearchValues from './getSearchValues';


export const filterSearchResults = ({ searchResults, allFields, searchParameters, fieldLookups }) => {
  const newSR = JSON.parse(JSON.stringify(searchResults));
  const trimFilters = [];
  const offerFilters = [];
  const modelFilters = [];

  for (const { slug, type, model:md } of allFields) {
    const model = md || 'allDriveNinjaTrimLevelType';

    const searchParam = getSearchValues({ searchParameters, slug, type });
    const filterSlug = fieldLookups[camelCase(slug)] || camelCase(slug);
    if (searchParam === true && type === 'bool') {
      if (model === 'allDriveNinjaTrimLevelType') {
        trimFilters.push(({ hasFeatures,...rest }) => {
          return( hasFeatures?.length && hasFeatures?.indexOf(filterSlug) !== -1)|| rest[filterSlug]===true;
        });
      }
    } else if (searchParam?.length > 0 && (type === 'term' || type === 'name' || type === 'names')) {
      if (model === 'allDriveNinjaCarOfferType' || model === 'allDriveNinjaCarOfferType') {
        offerFilters.push(o => searchParam.some(v => {
          const searchValue = v.toString();
          const arrayToSearch = Array.isArray(o[filterSlug]) ? o[filterSlug] : [o[filterSlug]];
          return arrayToSearch.map(v => v?.toString()).includes(searchValue);
        }));
      } else if (slug === 'manufacturer') {
        modelFilters.push((m) => searchParam.includes(m[slug]));
      } else if (slug === 'model') {
        modelFilters.push((m) => {
          return searchParam.includes(m.slug);
        });
      } else {
        trimFilters.push(tl => searchParam.some(v => {
          const searchValue = v.toString();
          const a = Array.isArray(tl[filterSlug]) ? tl[filterSlug] : [tl[filterSlug]];
          const arrayToSearch = a.map(v=>v.toString());

          return arrayToSearch.map(v => v.toString()).includes(searchValue);
        }));
      }
    } else if (type === 'int' || type === 'float') {
      const filters = ['allDriveNinjaPurchasableOfferType', 'allDriveNinjaCarOfferType'].indexOf(model) === -1 ? trimFilters : offerFilters;
      if (searchParam?.min && (type === 'int' || type === 'float')) {
        filters.push(ob => (ob && ob[filterSlug] >= searchParam.min));
      }
      if (searchParam?.max && (type === 'int' || type === 'float')) {
        filters.push(ob => {
          return (ob && ob[filterSlug] <= searchParam.max);
        });
      }
    }
  }


  const models = newSR.filter(m => {
    if (!modelFilters.length) {
      return true;
    }
    for (const ftr of modelFilters) {
      if (!ftr(m)) {
        return false;
      }
    }
    return true;
  }).map(m => {
    const model = { ...m };
    for (const filter of trimFilters) {
      model.trimLevels = model.trimLevels.filter(filter).map(tl => {
        const newTl = { ...tl };
        return newTl;
      });
    }
    for (const oFilter of offerFilters) {
      for (const tl of model.trimLevels) {
        tl.offers = tl.offers.filter(oFilter);
      }
    }
    model.trimLevels = model.trimLevels.filter(tl => tl.offers.length > 0);
    return model;
  });

  const pl = models.filter(model => model.trimLevels.length > 0);
  return pl;
};